import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/login'
import details from '@/components/details/details'
import record from '@/components/record/record'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      beforeEnter: (to, from, next) => {
        window.document.body.style.backgroundColor = '#fff'
        next()
      }
    },
    {
      path: '/',
      name: 'details',
      component: details,
      beforeEnter: (to, from, next) => {
        window.document.body.style.backgroundColor = '#fff'
        next()
      },
    },
    {
      path: '/record',
      name: 'record',
      component: record,
      beforeEnter: (to, from, next) => {
        window.document.body.style.backgroundColor = '#f0f0f0'
        next()
      }
    },
  ],

})

router.beforeEach((to, from, next) => {

  //console.log(to)

  if(to.path == '/login'){
    if (window.localStorage.userUserID){
      next()
      router.push({path:'./'})
    }else{
      next()
    }
  }
  if(to.path == '/' || to.path == '/record'){
    if (window.localStorage.userUserID){
      next()
    }else{
      router.push({path:'login'})
    }
  }
  // if (to.name == './'){
  //   if(window.localStorage.userID){
  //     next()
  //   }else{
  //     router.push({path:'./login'})
  //   }
  // }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js